import React from 'react'
import { css, useTheme } from '@emotion/react'
import { mediaQueries } from '../../theme'

const Divider = ({ size = 'medium', ...rest }) => {
  const theme = useTheme()
  return (
    <div
      {...rest}
      css={css`
        display: flex;
        align-items: center;
        text-align: center;
        color: ${theme.colors.divider.text};
        &:before,
        &:after {
          content: '';
          flex: 1;
          border-bottom: 1px solid ${theme.colors.divider.border};
        }

        ${size === 'small' &&
        `
            margin: ${theme.space[5]} ${theme.space[0]};
            font-size: ${theme.fontSizes[0]};
            &:before {
              margin-right: 1.15em;
              ${mediaQueries.sm} {
                margin-right: 1.675em;
              }
            }
            &:after {
              margin-left: 1.15em;
              ${mediaQueries.sm} {
                margin-left: 1.675em;
              }
            }
          `}

        ${size === 'medium' &&
        `
            margin: ${theme.space[8]} ${theme.space[0]};
            font-size: ${theme.fontSizes[2]};
            &:before {
              margin-right: 1.325em;
              ${mediaQueries.sm} {
                margin-right: 1.325em;
              }
            }
            &:after {
              margin-left: 1.325em;
              ${mediaQueries.sm} {
                margin-left: 1.325em;
              }
            }
          `}
      `}
    ></div>
  )
}

export default Divider
